import React from 'react';
import { Box, Tabs, Tab, Paper, useMediaQuery, useTheme } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

export interface HubTab {
  key: string;
  label: string;
  icon?: React.ReactElement;
  element: React.ReactNode;
}

// Contenedor reutilizable de "hub" con pestañas. Cada pestaña renderiza una página
// existente sin cambiarla. La pestaña activa se sincroniza con ?tab= para deep-links
// y para que el menú lateral resalte correctamente. Solo se monta la pestaña activa.
const TabHub: React.FC<{ tabs: HubTab[] }> = ({ tabs }) => {
  const [params, setParams] = useSearchParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const currentKey = params.get('tab') || tabs[0].key;
  let idx = tabs.findIndex((t) => t.key === currentKey);
  if (idx < 0) idx = 0;
  const active = tabs[idx];

  const handleChange = (_: React.SyntheticEvent, i: number) => {
    setParams({ tab: tabs[i].key });
  };

  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          mb: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          position: 'sticky',
          top: 0,
          zIndex: 3,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={idx}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          {tabs.map((t) => (
            <Tab
              key={t.key}
              label={t.label}
              icon={isMobile ? undefined : t.icon}
              iconPosition="start"
              sx={{ minHeight: 56, textTransform: 'none', fontWeight: 600 }}
            />
          ))}
        </Tabs>
      </Paper>
      {/* key fuerza remonte al cambiar de pestaña -> estado fresco por página */}
      <Box key={active.key}>{active.element}</Box>
    </Box>
  );
};

export default TabHub;
